interface IsSegmentPerformanceMetricsErrorParams {
  message: string
}

/**
 * The Segment SDK's internal performance-metrics beacon — `RemoteMetrics`, which counts SDK health
 * stats and is distinct from the `track`/`page`/`identify` calls carrying our analytics — logs this
 * prefix via `console.error` (which RUM captures as a `source:console` error) and appends whatever
 * its POST threw, so the suffix is whatever the browser calls a failed fetch.
 *
 * Dropping the log does not drop the signal. The beacon posts to `/seg-api/v1/m`, a first-party path
 * our Next rewrite proxies to Segment, and RUM records that request as a resource event either way —
 * a proxy fault surfaces there as a status code, which a `console.error` saying `Failed to fetch`
 * (no response at all) never can. What this filter removes is the SDK's unstructured commentary on a
 * request we already measure. We match Segment's phrase rather than the network text so a genuine
 * first-party `Failed to fetch` stays reported.
 */
const SEGMENT_PERFORMANCE_METRICS_ERROR_MESSAGE = 'Error sending segment performance metrics'

export const isSegmentPerformanceMetricsError = ({ message }: IsSegmentPerformanceMetricsErrorParams): boolean =>
  message.includes(SEGMENT_PERFORMANCE_METRICS_ERROR_MESSAGE)
